import React, { useEffect, useState } from 'react';
import { apiHandler } from '../../../api/apihandler';
import { NOTIFICATION_LIST, NOTIFICATION_READ, NOTIFICATION_DELETE } from '../../../api/constants';
import { apiSucceeded, formatRelativeTime, getAvatarColor, getInitials } from '../feed/feedUtils';
import PeopleYouMayKnowWidget from '../../../components/nemonto/PeopleYouMayKnowWidget';
import MyStatsWidget from '../../../components/nemonto/MyStatsWidget';
import PromoCard from '../../../components/nemonto/PromoCard';
import EmptyState from '../../../components/nemonto/EmptyState';
import './social-list-page.css';

const NotificationAvatar = ({ photo, name }) => {
  if (photo) return <img src={photo} alt="" className="nmsl-avatar" />;
  return (
    <div className="nmsl-avatar" style={{ background: getAvatarColor(name || 'User') }}>
      {getInitials(...(name || 'User').split(' '))}
    </div>
  );
};

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  async function loadNotifications() {
    setLoading(true);
    try {
      const res = await apiHandler(NOTIFICATION_LIST, 'POST', { page: 1, limit: 50 });
      if (apiSucceeded(res)) setNotifications(res?.data?.data?.notifications?.data || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }

  useEffect(() => { loadNotifications(); }, []);

  async function markRead(n) {
    if (n.is_read === 1) return;
    setNotifications((prev) => prev.map((item) => (item.id === n.id ? { ...item, is_read: 1 } : item)));
    try {
      await apiHandler(NOTIFICATION_READ, 'POST', { notification_id: n.id });
    } catch (e) { console.error(e); }
  }

  async function deleteNotification(n) {
    const prev = notifications;
    setNotifications((list) => list.filter((item) => item.id !== n.id));
    try {
      const res = await apiHandler(NOTIFICATION_DELETE, 'DELETE', { notification_id: n.id });
      if (!apiSucceeded(res)) setNotifications(prev);
    } catch (e) {
      console.error(e);
      setNotifications(prev);
    }
  }

  return (
    <div className="nmsl-layout">
      <div className="nmsl-main">
        <div className="nmsl-page-header">
          <div className="nmsl-header">
            <h3 className="nmsl-title">Notifications</h3>
            {notifications.length > 0 && <span className="nmsl-count-pill">{notifications.length}</span>}
          </div>
          <p className="nmsl-subtitle">Stay on top of likes, comments, and new followers.</p>
        </div>

        <div className="nmsl-main-body">
          {loading && <p className="nmsl-loading">Loading…</p>}
          {!loading && notifications.length === 0 && (
            <EmptyState icon="notifications" title="You're all caught up" sub="Likes, comments, and new followers will show up here." />
          )}

          {!loading && notifications.map((n) => (
            <div
              key={n.id}
              className={`nmsl-card nmsl-clickable ${n.is_read ? '' : 'nmsl-unread'}`}
              onClick={() => markRead(n)}
            >
              <NotificationAvatar
                photo={n?.user?.user_setting?.photo}
                name={`${n?.user?.first_name || ''} ${n?.user?.last_name || ''}`}
              />
              <div className="nmsl-body">
                <div className={`nmsl-notif-text ${n.is_read ? '' : 'nmsl-unread-text'}`}>{n.description}</div>
                <div className="nmsl-meta">{formatRelativeTime(n.created_at)}</div>
              </div>
              <button
                type="button"
                className="nmsl-icon-btn"
                onClick={(e) => { e.stopPropagation(); deleteNotification(n); }}
                title="Delete"
              >
                <span className="material-symbols-outlined" style={{ fontSize: 16 }}>delete</span>
              </button>
            </div>
          ))}
        </div>
      </div>

      <aside className="nmsl-rail">
        <PromoCard
          label="For creators"
          title="Got a recipe worth competing for?"
          sub="Set the rules, set the clock, and pick the winner yourself."
          ctaText="Host a challenge"
          to="/pages/challenge-submit"
        />
        <PeopleYouMayKnowWidget />
        <MyStatsWidget />
      </aside>
    </div>
  );
};

export default NotificationsPage;
